export const InvoiceStatuses = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
} as const;

export type InvoiceStatus = typeof InvoiceStatuses[keyof typeof InvoiceStatuses];
